import React, { lazy, Suspense, useEffect, useState } from "react";
import { Amplify } from "aws-amplify";
import { config } from "../amplify_outputs";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { fetchAuthSession } from "aws-amplify/auth";
import { ConstantsRolesProps, RolesProps } from "./routes.model";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { RoleGuard } from "../guards";


import RoutesWithNotFound from "../utils/RoutesWithNotFound.utility";
import "@aws-amplify/ui-react/styles.css";

const HomePage = lazy(() => import("../pages/form"));
const DashboardPage = lazy(() => import("../pages/dashboard/dashboard"));

Amplify.configure(config);

const Routes: React.FC<{}> = () => {
  const { authStatus } = useAuthenticator();
  const [groups, setGroups] = useState<Array<string>>([]);

  useEffect(() => {
    if (authStatus === "authenticated") {
      fetchAuthSession().then((auth) => {
        const token = auth.tokens?.idToken;
        globalThis.TOKEN_JWT = token?.toString();
        const cognitoGroups = token?.payload["cognito:groups"];
        setGroups((cognitoGroups as Array<ConstantsRolesProps>) || []);
      });
    }
  }, [authStatus]);

  return (
    <Suspense fallback={<>Cargando</>}>
      <Router>
        <RoutesWithNotFound>
          <Route
            element={
              <RoleGuard
                roles={groups}
                roleCondition={RolesProps.G_AUTOMATION_FORM_VENTANERO}
              />
            }
          >
            <Route path="/" element={<HomePage/>} />
            <Route path="/dashboard" element={<DashboardPage/>} />
          </Route>
        </RoutesWithNotFound>
      </Router>
    </Suspense>
  );
};

export default Routes;
